/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
import { joiResolver } from "@hookform/resolvers/joi";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import VmoForm from "../Collections/VmoForm/VmoForm";
import VmoFormInput from "../Collections/VmoForm/VmoFormInput";
import VmoButton from "../Elements/VmoButton/VmoButton";
import VmoCardContent from "../Views/VmoCard/VmoCardContent";
import VmoCard from "../Views/VmoCard/VmoCard";
import { useForm, Controller } from "react-hook-form";
import { updateEmailSchema } from "../Validation/common.schema";
import VmoModal from "../Modules/Modal/VmoModal";
import VmoModalContent from "../Modules/Modal/VmoModalContent";
import { VmoModalHeader } from "vmo-library";
export default function VmoUpdateEmail({
  disabled = false,
  btnLabel = "Submit",
  loading,
  modalProps = {
    open: true,
    size: "tiny",
    closeIcon: true,
    closeOnDimmerClick: true,
  },
  onSubmit = (data) => null,
}) {
  const [requestId, setRequestId] = React.useState(null);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const requestId = urlParams.get("requestId");
    if (requestId) {
      setRequestId(requestId);
    }
  }, []);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(updateEmailSchema),
  });
  const onUpdate = (data) => {
    const e = {
      ...data,
      requestId,
    };
    onSubmit(e);
  };
  function _renderLayout() {
    return (
      <React.Fragment>
        <p>Try with another new email id!!</p>
        <VmoForm size="large">
          <Controller
            name="email"
            render={({ field: { onChange, value } }) => (
              <VmoFormInput
                fluid
                icon={"mail"}
                iconPosition="left"
                placeholder="Email address"
                value={value}
                onChange={(e) => {
                  onChange(e.target.value);
                }}
                error={
                  errors.email && {
                    content: errors.email.message,
                  }
                }
              />
            )}
            control={control}
          />
          <VmoButton
            primary
            type="submit"
            fluid
            size="large"
            disabled={disabled}
            loading={loading}
            onClick={handleSubmit(onUpdate)}
          >
            {btnLabel}
          </VmoButton>
        </VmoForm>
      </React.Fragment>
    );
  }
  return (
    <VmoModal {...modalProps}>
      <VmoModalHeader>Change Your Email Address</VmoModalHeader>
      <VmoModalContent>{_renderLayout()}</VmoModalContent>
    </VmoModal>
  );
}

VmoUpdateEmail.defaultProps = {
  disabled: false,
  loading: false,
  btnLabel: "Submit",
  modalProps: {
    open: false,
    size: "mini",
    closeIcon: true,
    closeOnDimmerClick: true,
    onClose: () => null,
    onOpen: () => null,
    trigger: null,
  },
  onSubmit: (data) => null,
};

VmoUpdateEmail.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  btnLabel: PropTypes.string.isRequired,
  modalProps: PropTypes.shape({
    open: PropTypes.bool,
    size: PropTypes.oneOf(["mini", "tiny", "small", "large", "fullscreen"]),
    closeIcon: PropTypes.bool,
    closeOnDimmerClick: PropTypes.bool,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    trigger: PropTypes.node,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
};
